import React from 'react';

import styles from './ReportFilters.module.scss';

const ReportFilters = ({ children }) => {
	return <div className={styles.filters}>{children}</div>;
};

export default ReportFilters;
